import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
    AlertDescription,
    AlertProps,
    Alert as ChakraAlert
} from "@chakra-ui/react";

interface PropTypes extends AlertProps {
    type: "error";
    message: string;
}

const Alert = ({ type, message, ...alertProps }: PropTypes) => {
    return (
        <ChakraAlert
            status={type}
            bg="sunsetRed.100"
            p={5}
            borderRadius={12}
            {...alertProps}
        >
            <FontAwesomeIcon
                color="var(--euka-colors-sunsetRed-500)"
                icon={faExclamationTriangle}
                fontSize={14}
            />
            <AlertDescription fontSize={16} ml={3} color="sunsetRed.500">
                {message}
            </AlertDescription>
        </ChakraAlert>
    );
};

export default Alert;
